"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMoveWidgetDropHandler = void 0;
// (C) 2022 GoodData Corporation
var react_1 = require("react");
var model_1 = require("../../../model");
var model_2 = require("../../../model/");
function useMoveWidgetDropHandler(sectionIndex, itemIndex) {
    var dispatch = model_1.useDashboardDispatch();
    return react_1.useCallback(function (item) {
        var targetIndex = itemIndex;
        if (item.sectionIndex === sectionIndex) {
            // if the item is moved within the same section to bigger index, indexes are shifted by 1
            if (item.itemIndex < itemIndex) {
                targetIndex = itemIndex - 1;
            }
            if (item.itemIndex === targetIndex) {
                // same positions we do not need to do anything
                return;
            }
        }
        dispatch(model_2.moveSectionItemAndRemoveOriginalSectionIfEmpty(item.sectionIndex, item.itemIndex, sectionIndex, targetIndex));
    }, [dispatch, itemIndex, sectionIndex]);
}
exports.useMoveWidgetDropHandler = useMoveWidgetDropHandler;
//# sourceMappingURL=useMoveWidgetHandler.js.map